import React from "react";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

type Props = {
  stepTitles: string[];
  stepStates: string[];
  nowCount: number;
};

export const OperationSidebar = ({ stepTitles, stepStates, nowCount }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <input id="menuopen-input" type="checkbox" checked />
      <div id="main-content-sidebar-operation">
        <div id="sidebar-main" className="sidebar-main components" style={{ left: 0, marginTop: "40px" }}>
          <div className="operation_sidebar">
            <h4 className="sidebar-header">
              <span>
                {t("OperationSidebar.ステップ")} {nowCount}/{stepTitles.length}
              </span>
            </h4>
            <ul className="nav flex-column mb-2 step-wrapper">
              {stepStates.map((state, i) => (
                <div className="step-item-wrapper" key={i}>
                  <li className="nav-item p-0">
                    <div className="nav-link step-item" data-testid="step-item">
                      {(() => {
                        switch (state) {
                          case "not_yet":
                            return (
                              <img
                                src={getImageUrl("images/icons/notYet.svg")}
                                width={16}
                                height={16}
                                className="step-icon test-not-yet"
                                data-testid="step-icon"
                              />
                            );
                          case "incomplete":
                            return (
                              <img
                                src={getImageUrl("images/icons/caution.svg")}
                                width={18}
                                height={18}
                                className="step-icon test-caution"
                                data-testid="step-icon"
                                style={{ marginLeft: "-1px" }}
                              />
                            );
                          case "success":
                            return (
                              <img
                                src={getImageUrl("images/icons/successCheck.svg")}
                                width={16}
                                height={16}
                                className="step-icon test-success"
                                data-testid="step-icon"
                              />
                            );
                          default:
                            return null;
                        }
                      })()}
                      <div className={`step-content${nowCount === i + 1 ? " active" : ""}`}>
                        <div className="step-title">{stepTitles[i]}</div>
                      </div>
                    </div>
                  </li>
                  {i < stepStates.length - 1 && (
                    <div className={`step-border${state === "success" ? " success" : ""}`}></div>
                  )}
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
